import React, { useState, useEffect } from "react";
import List from "../../styledComponents/Table/List";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import moreIcon from "../../../assets/images/DeathModuleNew/more_horiz1.png";

import SearchIcon from "../../../assets/images/DeathModuleNew/Search.png";
import DEATH_API from "../../../apis/death.api";
import Loader from "../../../components/styled-components/loader/loader";
import { Modal, Select } from "antd";
import Checkbox from "./Checkbox";
import swal from "sweetalert";
import "./roleMain.css";
const { Option } = Select;

export const RoleMain = () => {
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [updatedObject, setUpdateObject] = useState(null);

  const [roleModal, setRoleModal] = useState(false);
  const [roles, setRoles] = useState([]);
  const [formData, setFormData] = useState(null);
  const cols = [
    {
      title: "Role ID",
      dataIndex: "id",

      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Role Name",
      dataIndex: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Role Permission",
      render: (record, index) => {
        return (
          <div key={index}>
            {" "}
            <img
              style={{ cursor: "pointer", marginLeft: "1rem" }}
              src={moreIcon}
              alt="moreIcon"
              onClick={() => {
                console.log("recode", record.id);
                getSelectedRow(record.id);
                setRoleModal(true);
              }}></img>{" "}
          </div>
        );
      },
    },

    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                getSelectedRow(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                    setFormData(null);
                    setUpdateObject(null);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteSelectedRow(record.id);
                        setDropdown(false);
                      }}>
                      Delete
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        setRoleModal(true);
                        setDropdown(false);
                      }}>
                      Update
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  const getPermissionList = async () => {
    try {
      (async () => {
        setLoading(true);
        let data = await DEATH_API.getPermissions();
        if (data && data.data) {
          setList(data.data);
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    // let selectedChecks=Catalogues.map(catalogue => catalogue.id)
    // setIsCheck(selectedChecks);
  };

  const getRolesList = async () => {
    try {
      (async () => {
        setLoading(true);

        let data = await DEATH_API.getRoles();
        if (data && data.data) {
          setRoles(data.data);
        }
        setLoading(false);
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    getRolesList();
    getPermissionList();
  }, []);
  const getSelectedRow = (id) => {
    setSelectedIndex(id);
    let selectedRow = roles.filter((row, index) => {
      return row.id == id;
    });

    console.log("selectedRow", selectedRow[0]);
    setFormData(selectedRow[0]);
    setUpdateObject(selectedRow[0]);
    const permissionIDs = selectedRow[0].permissions.map(
      (permission) => permission.id
    );
    console.log(permissionIDs);
    setIsCheck(permissionIDs);
  };
  const handleOk = () => {
    setRoleModal(false);
    setFormData(null);
    setUpdateObject(null);
  };

  const createRole = async () => {
    // check if already formData contains some data then initialize it with empty
    setRoleModal(false);
    try {
      setLoading(true);
      let api_res = await DEATH_API.addRoles({
        name: formData.name,
        permissions: isCheck,
      });
      setLoading(false);
      if (api_res && api_res.status === 400) {
        swal("Error", api_res.message, "error");
      }
      getRolesList();
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
    setFormData(null);
    setUpdateObject(null);
    setIsCheck([]);
    setIsCheckAll(false);
  };
  const updateRole = async () => {
    // check if already formData contains some data then initialize it with empty
    setRoleModal(false);
    try {
      setLoading(true);
      let payload = {
        name: formData.name,
        permissions: isCheck,
      };
      let api_res = await DEATH_API.updateRole(selectedIndex, payload);
      setLoading(false);
      getRolesList();
    } catch (error) {
      console.log(error);
      setLoading(false);
      throw new Error(error);
    }
    setFormData(null);
    setUpdateObject(null);
    setIsCheck([]);
    setIsCheckAll(false);
  };

  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteRole(idx);
          setLoading(false);
          setFormData(null);
          setUpdateObject(null);
          setIsCheck([]);
          setIsCheckAll(false);
          getRolesList();
        } catch (error) {
          console.log("error deleting Role");
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Role has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your Role is safe :)", "error");
      }
    });
  };
  const handleCancel = () => {
    setRoleModal(false);
    setFormData(null);
    setUpdateObject(null);
    setIsCheck([]);
    setIsCheckAll(false);
  };
  const handleInputChnage = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const handleSearch = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setSearchTerm(searchTerm);
    const filteredResults =
      roles &&
      roles.filter((item) => item.name.toLowerCase().includes(searchTerm));
    setFilteredData(filteredResults);
  };

  const Catalogues = [
    {
      id: 25,
      name: "Chicken",
    },
    {
      id: 155,
      name: "Beef",
    },
    {
      id: 30,
      name: "Lamb",
    },
    {
      id: 4,
      name: "Pork",
    },
    {
      id: 5,
      name: "Seafood",
    },
    {
      id: 6,
      name: "Dairy",
    },
    {
      id: 7,
      name: "Tofu",
    },
    {
      id: 8,
      name: "Vegan",
    },
  ];

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState(Catalogues);

  // useEffect(() => {
  //   setList(Catalogues);
  // }, [list]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    console.log(id, "iddddddddd");
    setIsCheck([...isCheck, +id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== +id));
    }
  };

  console.log("ischecked", isCheck);

  const catalog = list.map(({ id, name }) => {
    let selectedChecks = Catalogues.map((catalogue) => catalogue.id);
    // setIsCheck(selectedChecks)
    return (
      <div style={{ width: "30%" }}>
        {console.log(
          "Catalogues.includes(id)",
          selectedChecks.includes(id),
          id
        )}
        <label className="container1">
          <Checkbox
            key={id}
            type="checkbox"
            name={name}
            id={id}
            handleClick={handleClick}
            isChecked={isCheck.includes(id)}
          />
          <span id={id} className="checkmark"></span>
          {name}
        </label>
      </div>
    );
  });

  return (
    <div className="mainRole">
      <div className="rolesTable">
        <div className="RolesHeader">
          <div className="RoleTitle">Roles List</div>

          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                border: "1px solid #2a3da3",
                borderRadius: "5px",
                marginRight: "1rem",
                height: "2rem",
              }}>
              <img
                style={{ marginTop: "6px", marginLeft: "6px" }}
                width={"20px"}
                height={"20px"}
                src={SearchIcon}
                alt="search"></img>
              <input
                className="searchInput"
                type="text"
                name="search"
                placeholder="Search"
                onChange={handleSearch}></input>
            </div>
            <label
              className="labelStyle"
              onClick={() => {
                setRoleModal(true);
              }}>
              +
            </label>
          </div>
        </div>
        <List
          cols={cols}
          rows={filteredData && filteredData.length > 0 ? filteredData : roles}
        />
      </div>
      {roleModal && (
        <Modal
          visible={roleModal}
          footer={null}
          // onOk={handleOk}
          // onCancel={handleCancel}
          closable={false}
          centered>
          <h3 className="modaltitle">
            {updatedObject && updatedObject ? "Update Role" : "Add New Role"}
          </h3>
          <h3 className="inputTitle">Role Name</h3>

          <input
            className="roleInput"
            placeholder="Role Name"
            name="name"
            value={formData && formData.name}
            id="role"
            onChange={(e) => {
              e.preventDefault();
              handleInputChnage(e.target.name, e.target.value);
            }}
          />
          <h3 className="inputTitle">Permissions Name</h3>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: " 1rem",
              maxHeight: "20rem",
              overflow: "scroll",
              padding: "1rem",
              gap: "1rem",
            }}>
            <div style={{ width: "30%" }}>
              <label className="container1">
                <Checkbox
                  type="checkbox"
                  name="selectAll"
                  id="selectAll"
                  handleClick={handleSelectAll}
                  isChecked={isCheckAll}
                />
                <span id="selectAll" className="checkmark"></span>
                Select All
              </label>
            </div>
            {catalog}
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              onClick={() => {
                handleCancel();
              }}>
              Cancel
            </button>
            <button
              className="savebutton"
              onClick={() => {
                if (updatedObject) {
                  updateRole();
                } else {
                  createRole();
                }
              }}>
              Save
            </button>
          </div>
        </Modal>
      )}
      <Loader isLoading={loading} />
    </div>
  );
};
